'use client';

import { useEffect, useRef } from 'react';
import { Element, ElementProps } from '../element';
import * as styles from './animatedNumber.css';

interface AnimatedNumberProps {
  value: number;
  suffix?: string;
  typography?: ElementProps['typography'];
  color?: ElementProps['color'];
  className?: string;
}

export const AnimatedNumber = ({
  value,
  suffix = '원',
  typography,
  color,
  className,
}: AnimatedNumberProps) => {
  const digitRefs = useRef<(HTMLDivElement | null)[]>([]);

  useEffect(() => {
    const numStr = value.toLocaleString();
    digitRefs.current.forEach((ref, idx) => {
      if (!ref) return;

      const char = numStr[idx];
      if (char >= '0' && char <= '9') {
        const number = parseInt(char, 10);
        const digitHeight = ref.offsetHeight / 10;
        ref.style.top = `${-number * digitHeight}px`;
      }
    });
  }, [value]);

  const renderDigit = (char: string, index: number) => {
    if (char >= '0' && char <= '9') {
      return (
        <span key={index} className={styles.digitContainer}>
          <div
            ref={(el: HTMLDivElement | null): void => {
              digitRefs.current[index] = el;
            }}
            className={styles.digit}>
            {[0, 1, 2, 3, 4, 5, 6, 7, 8, 9].map(num => (
              <div key={num}>{num}</div>
            ))}
          </div>
        </span>
      );
    }
    return <span key={index}>{char}</span>;
  };

  return (
    <Element typography={typography} color={color} className={className}>
      {value
        .toLocaleString()
        .split('')
        .map((char, i) => renderDigit(char, i))}
      {suffix}
    </Element>
  );
};
